export interface IGenericTreeNode {
  children?: IGenericTreeNode[];

  expanded?: boolean;

  icon?: string;

  id: string;

  label: string | undefined;

  secondaryLabel?: string | null;

  parentId?: string;

  checked?: boolean;

  indeterminate?: boolean;

  loading?: boolean;

  childrenCount?: number;

  checkedChildrenCount?: number;

  selected?: boolean;

  isDirty?: boolean; // set to true whenever a user checks or unchecks a node

  disabled?: boolean;

  inherited?: boolean;
}
